/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Enumeration of reasons a NetworkResource may be unavailable.
 * Used by NetworkResourceAvailability.getFailureReason() to provide
 * diagnostic context to consumers.
 */
enum NetworkResourceFailureReason {
  /** No network interface is connected or has a valid IP address. */
  NETWORK_INTERFACE_DOWN = "NETWORK_INTERFACE_DOWN",

  /** Internet probing failed — device cannot reach the external Internet. */
  INTERNET_UNREACHABLE = "INTERNET_UNREACHABLE",

  /** A network request timed out, suggesting Internet or endpoint issues. */
  TIMEOUT = "TIMEOUT",

  /** DNS resolution failed; separated from Internet availability. */
  DNS_RESOLUTION_FAILED = "DNS_RESOLUTION_FAILED",

  /** The failure reason could not be determined. */
  UNKNOWN = "UNKNOWN"
}

export { NetworkResourceFailureReason };
